import { render, staticRenderFns } from "./TenantAuth.vue?vue&type=template&id=4d0f7e1e&scoped=true&"
import script from "./TenantAuth.vue?vue&type=script&lang=js&"
export * from "./TenantAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0f7e1e",
  null
  
)

export default component.exports